import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import calendar from 'dayjs/plugin/calendar'
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
dayjs.extend(calendar)

export function formatDate (v, format, calendarFormat) {
  if (!v) return ''
  const myDayjs = dayjs(v)
  if (format) return myDayjs.format(format)
  const nowDayjs = dayjs()
  const diffM = nowDayjs.diff(myDayjs, 'minute')
  const diffDays = nowDayjs.clone().startOf('date').diff(myDayjs.clone().startOf('date'), 'day')
  const {
    yesterday,
    twoDaysAgo,
    sameYear,
    anotherYear,
    tomorrow
  } = calendarFormat || {}
  return myDayjs.calendar(null, {
    sameDay: () => {
      if (diffM < 0) {
        return myDayjs.format('HH:mm')
      }
      if (diffM < 1) {
        return '刚刚'
      }
      if (diffM < 10) {
        return `${diffM} 分钟前`
      }
      return myDayjs.format('HH:mm')
    },
    lastDay: yesterday || `[昨天] HH:mm`,
    lastWeek: diffDays === 2 ? (twoDaysAgo || `前天 HH:mm`) : (sameYear || `MM/DD HH:mm`),
    sameElse: myDayjs.year() === nowDayjs.year() ? (sameYear || `MM/DD HH:mm`) : (anotherYear || `YYYY/MM/DD HH:mm`),
    nextDay: tomorrow || '[明天] HH:mm',
    nextWeek: sameYear || 'MM/DD HH:mm'
  })
}
